import React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { LogicTreePageQuery$data } from "./__generated__/LogicTreePageQuery.graphql";
import { TabContainer } from "./SourceBranchesTab";
import { Typography } from "@mui/material";

export interface GroundMotionBranchesTableProps {
  data: LogicTreePageQuery$data;
}
export interface DataGridTitleProps {
  title: string;
}

export const GroundMotionBranchesTab = ({ data }: GroundMotionBranchesTableProps) => {
  return (
    <TabContainer>
      <Typography variant="h5" gutterBottom>
        Ground Motion Branches for: {data?.get_model?.version}
      </Typography>
      <GroundMotionBranchesTable data={data} />
    </TabContainer>
  );
};

export const GroundMotionBranchesTable: React.FC<GroundMotionBranchesTableProps> = ({
  data,
}: GroundMotionBranchesTableProps) => {
  const columns: GridColDef[] = [
    {
      field: "gsim_name",
      headerName: "gsim_name",
      width: 400,
      renderHeader: () => <strong>gsim_name</strong>,
    },
    { field: "gsim_args", headerName: "gsim_args", width: 500, renderHeader: () => <strong>gsim_args</strong> },
    { field: "weight", headerName: "Weight", width: 200, renderHeader: () => <strong>Weight</strong> },
  ];

  const branches = data?.get_model?.gmm_logic_tree?.branch_sets?.map((branch) => {
    return branch;
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getRows = (branch: { branches: any }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return branch?.branches?.map((branch: any, i: number) => {
      return {
        id: i,
        gsim_name: branch?.gsim_name,
        gsim_args: branch?.gsim_args,
        weight: branch?.weight,
      };
    });
  };

  return (
    <Box sx={{ minHeight: 400, width: "100%" }}>
      {branches
        ? branches.map((branch, i) => (
            <Box key={i}>
              <Box style={{ width: "100%", display: "flex", margin: "20px" }}>
                <Typography variant="h5">
                  {branch?.long_name} ({branch?.tectonic_region_type})
                </Typography>
              </Box>
              <DataGrid
                sx={{ overflowX: "scroll" }}
                hideFooter
                autoHeight
                rows={branch ? getRows(branch) : []}
                columns={columns}
              />
            </Box>
          ))
        : "No data"}
    </Box>
  );
};
